import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import StickyHead from "../StickyHead";

/* 라오나 상품 연결 — 라오나 모듈 · 브레드보드가 쇼핑몰 상품과 제대로 이어졌는지 점검 (백엔드 app/sstoa/api/laona_links.py)
   회원의 [장바구니에 담기]에서 '담기 가능'이 되려면 모듈이 상품에 이어져 있고, 그 상품이 공개이며 가격이 있어야 한다.
   상품 연결은 라오나 모듈 관리(/laonabot/wiring?tab=editor)에서 상품을 골라서 하고, 가격 · 공개는 제품 관리에서 정한다.
   연결 규칙은 app/laona_shop.py — 모듈은 product_id 로 상품을 잇고 상품코드는 서버가 상품에 맞춘다. */

const STATE = {
  code_only: { label: "코드만 있음", tone: "red", tip: "상품코드만 적혀 있고 그 코드의 쇼핑몰 상품이 없습니다. 모듈 관리에서 상품을 고르거나 [상품 만들기]를 누르세요." },
  hidden: { label: "상품 공개 전", tone: "amber", tip: "공개 전(DRAFT) · 숨김 상품이라 쇼핑몰에 안 보여 '쇼핑몰 미등록'으로 나옵니다. 제품 관리에서 공개해 주세요." },
  no_price: { label: "가격 없음", tone: "amber", tip: "가격이 없는 상품이라 '가격 문의'로 나오고 담기지 않습니다. 제품 관리에서 가격을 넣어 주세요." },
  soldout: { label: "품절", tone: "amber", tip: "품절 상품이라 담기지 않습니다." },
  none: { label: "연결 없음", tone: "gray", tip: "쇼핑몰 상품이 연결되지 않아 '판매 준비 중'으로 나옵니다." },
  ok: { label: "담기 가능", tone: "green", tip: "회원 장바구니에 담깁니다." },
};
const ORDER = ["code_only", "hidden", "no_price", "soldout", "none", "ok"];
const P_ST = { DRAFT: "공개 전", ACTIVE: "판매 중", SOLDOUT: "품절", HIDDEN: "숨김" };
const won = (n) => `${Number(n || 0).toLocaleString("ko-KR")}원`;
const TONE = {
  red: { color: "#c0392b", borderColor: "currentColor" },
  amber: { color: "#a86f00", borderColor: "currentColor" },
  green: { color: "#1d8549", borderColor: "currentColor" },
};

export default function LaonaLinksAdmin() {
  const [data, setData] = useState(null);
  const [all, setAll] = useState(false);
  const [filter, setFilter] = useState("todo"); // todo: 손볼 것 · ok · "" 전체
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [busy, setBusy] = useState(false);

  async function load(a = all) {
    setError("");
    try { setData(await api.get(`/laona-links${a ? "?all=1" : ""}`)); }
    catch (err) { setError(err.message); }
  }
  useEffect(() => { load(all); }, [all]); // eslint-disable-line react-hooks/exhaustive-deps

  async function relink() {
    setBusy(true);
    setError("");
    setNotice("");
    try {
      const r = await api.post("/laona-links/relink", {});
      setNotice(`새로 연결 ${r.linked}개 · 코드 맞춤 ${r.refreshed}개 · 없어진 상품 연결 풀기 ${r.dropped}개`
        + (r.unmatched.length ? ` · 같은 코드의 상품이 없는 것 ${r.unmatched.length}개` : ""));
      await load();
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  }

  const items = data ? data.items.filter((it) => (filter === "todo" ? it.state !== "ok" : filter === "ok" ? it.state === "ok" : true)) : [];
  const todo = data ? data.total - data.counts.ok : 0;

  return (
    <div>
      <StickyHead>
        <div style={{ marginBottom: 12 }}>
          <Link to="/sstoa" className="sstoa-back">← 홈</Link>
        </div>

        <div className="sstoa-topbar">
          <div>
            <h1 className="sstoa-title">라오나 상품 연결</h1>
            <p className="sstoa-sub">
              라오나 모듈 · 브레드보드가 쇼핑몰 상품과 이어졌는지 점검합니다. 회원이 내 프로젝트에서 [장바구니에 담기]를 누를 때
              ‘담기 가능’이 되려면 상품이 연결되어 있고, 그 상품이 공개이며 가격이 있어야 합니다. 상품 연결은 라오나 모듈 관리에서
              상품을 골라서 하고(상품이 없으면 [상품 만들기]), 가격 · 공개는 제품 관리에서 정합니다.
            </p>
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <a className="sstoa-btn" href="/laonabot/wiring?tab=editor" target="_blank" rel="noreferrer">모듈 관리 열기</a>
            <button className="sstoa-btn" onClick={relink} disabled={busy}
                    title="연결된 상품의 코드로 다시 맞추고, 상품코드만 적힌 것은 같은 코드의 상품이 있으면 잇습니다">
              {busy ? "맞추는 중…" : "연결 다시 맞추기"}
            </button>
          </div>
        </div>

        <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap", alignItems: "center" }}>
          {[["todo", `손볼 것${data ? ` ${todo}` : ""}`], ["ok", `담기 가능${data ? ` ${data.counts.ok}` : ""}`], ["", `전체${data ? ` ${data.total}` : ""}`]].map(([v, l]) => (
            <button key={v} className={`sstoa-btn sstoa-btn--sm${filter === v ? " sstoa-btn--primary" : ""}`} onClick={() => setFilter(v)}>{l}</button>
          ))}
          <label className="sstoa-hint" style={{ display: "inline-flex", gap: 6, alignItems: "center", marginLeft: 8, cursor: "pointer" }}>
            <input type="checkbox" checked={all} onChange={(e) => setAll(e.target.checked)} />
            비공개 모듈까지 보기
          </label>
        </div>
      </StickyHead>

      {data && todo > 0 && (
        <p className="sstoa-hint" style={{ marginBottom: 12 }}>
          {ORDER.filter((k) => k !== "ok" && data.counts[k]).map((k) => `${STATE[k].label} ${data.counts[k]}`).join(" · ")}
        </p>
      )}
      {notice && <div className="sstoa-hint" style={{ marginBottom: 12 }}>{notice}</div>}
      {error && <div className="sstoa-error" style={{ marginBottom: 12 }}>{error}</div>}

      <div className="sstoa-panel">
        {data === null ? (
          <div className="sstoa-empty">불러오는 중…</div>
        ) : items.length === 0 ? (
          <div className="sstoa-empty">{filter === "todo" ? "손볼 것이 없습니다. 모두 담기 가능합니다." : "항목이 없습니다."}</div>
        ) : (
          <table className="sstoa-table">
            <thead>
              <tr><th>상태</th><th>구분</th><th>모듈 · 브레드보드</th><th>상품코드</th><th>쇼핑몰 상품</th><th>가격</th><th></th></tr>
            </thead>
            <tbody>
              {items.map((it) => {
                const st = STATE[it.state];
                const p = it.product;
                return (
                  <tr key={`${it.kind}:${it.id}`}>
                    <td>
                      <span className={`sstoa-tag${st.tone === "gray" ? " sstoa-tag--gray" : ""}`} style={{ whiteSpace: "nowrap", ...(TONE[st.tone] || {}) }} title={st.tip}>
                        {st.label}
                      </span>
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {it.kind === "module" ? "모듈" : "브레드보드"}
                      {it.kind === "module" && !it.public && <span className="sstoa-tag sstoa-tag--gray" style={{ marginLeft: 6 }}>비공개</span>}
                    </td>
                    <td>
                      <b>{it.id}</b>
                      {it.name && it.name !== it.id && <div className="sstoa-hint">{it.name}</div>}
                    </td>
                    <td style={{ fontFamily: "monospace", whiteSpace: "nowrap" }}>
                      {it.code || "—"}
                      {it.code && !it.linked && p && <div className="sstoa-hint">코드로만 맞음 — [연결 다시 맞추기]</div>}
                    </td>
                    <td>
                      {p ? (
                        <>
                          {p.name}
                          <div className="sstoa-hint">{P_ST[p.status] || p.status} · {p.category || "분류 없음"}</div>
                        </>
                      ) : <span className="sstoa-hint">{st.tip}</span>}
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>{p ? (p.price != null ? won(p.price) : "—") : "—"}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {p ? (
                        <Link className="sstoa-btn sstoa-btn--sm" to={`/sstoa/site-products?edit=${p.id}`}>상품 고치기</Link>
                      ) : it.kind === "module" ? (
                        <a className="sstoa-btn sstoa-btn--sm" href="/laonabot/wiring?tab=editor" target="_blank" rel="noreferrer">모듈 관리</a>
                      ) : (
                        <a className="sstoa-btn sstoa-btn--sm" href="/laonabot/wiring" target="_blank" rel="noreferrer" title="브레드보드 탭의 [브레드보드 관리]에서 상품을 고릅니다">브레드보드 관리</a>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
